// extracted by mini-css-extract-plugin
export default {"wrap":"HomeLogo_wrap__rBhup","mark":"HomeLogo_mark__cUd2p","word":"HomeLogo_word__nCC6w"};